// Approximate coordinates for Montreal locations
export const getCoordinatesFromLocation = (location, title = '', neighborhood = '') => {
  const locationLower = (location + ' ' + title + ' ' + neighborhood).toLowerCase();

  // St-Denis area (Plateau Mont-Royal)
  if (locationLower.includes('st-denis') || locationLower.includes('st denis') || locationLower.includes('4618 rue st-denis')) {
    return {
      longitude: -73.5894,
      latitude: 45.5234,
      zoom: 15
    };
  }

  // Decarie area (NDG/Snowdon - Boulevard Décarie near Electric Circuit)
  if (locationLower.includes('decarie') || locationLower.includes('4586 boulevard decarie')) {
    return {
      longitude: -73.6282,
      latitude: 45.4745,
      zoom: 15
    };
  }

  // Default Montreal coordinates
  return {
    longitude: -73.5673,
    latitude: 45.5017,
    zoom: 12
  };
};
